module.exports = "/images/ki.svg?2533c6deaa0dddcc44dd5ac6ea02ccb3";